import { useTable } from "react-table";
import { Table as RBTable } from "react-bootstrap";
import { TableProps } from "../Table/Table.props";

const ExtendRowTable: React.FC<TableProps> = ({
    columns,
    data,
    className,
    customProp,
    customTableStyle,
    ...props
}) => {
    function useInstance(instance: any) {
        const { allColumns } = instance;

        let rowSpanHeaders: any = [];

        allColumns.forEach((column: any, i: number) => {
            const { id, enableRowSpan } = column;

            if (enableRowSpan !== undefined) {
                rowSpanHeaders = [
                    ...rowSpanHeaders,
                    { id, topCellValue: null, topCellIndex: 0 },
                ];
            }
        });

        Object.assign(instance, { rowSpanHeaders });
    }

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        //@ts-ignore
        rowSpanHeaders,
        //@ts-ignore
    } = useTable({ columns, data }, (hooks) => {
        hooks.useInstance.push(useInstance);
    });
    return (
        <RBTable
            {...props}
            {...getTableProps()}
            bordered
            className={`
                rtl
                ${className}
            `}
            {...getTableProps()}
        >
            <thead>
                {headerGroups.map((headerGroup: any) => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map((column: any) => (
                            <th {...column.getHeaderProps()}>
                                {column.render("Header")}
                            </th>
                        ))}
                    </tr>
                ))}
            </thead>
            <tbody {...getTableBodyProps()}>
                {rows.map((row: any, i: any) => {
                    prepareRow(row);

                    for (let j = 0; j < row.allCells.length; j++) {
                        let cell = row.allCells[j];
                        let rowSpanHeader = rowSpanHeaders.find(
                            (x: any) => x.id === cell.column.id
                        );

                        if (rowSpanHeader !== undefined) {
                            if (
                                rowSpanHeader.topCellValue === null ||
                                rowSpanHeader.topCellValue !== cell.value
                            ) {
                                //@ts-ignore
                                cell.isRowSpanned = false;
                                rowSpanHeader.topCellValue = cell.value;
                                rowSpanHeader.topCellIndex = i;
                                //@ts-ignore
                                cell.rowSpan = 1;
                            } else {
                                const res =
                                    rows[rowSpanHeader.topCellIndex].allCells[
                                        j
                                    ];
                                //@ts-ignore
                                res.rowSpan++;
                                //@ts-ignore
                                cell.isRowSpanned = true;
                            }
                        }
                    }
                    return null;
                })}
                {rows.map((row: any) => {
                    return (
                        <tr {...row.getRowProps()}>
                            {row.cells.map((cell: any) => {
                                //@ts-ignore
                                if (cell.isRowSpanned) return null;
                                else
                                    return (
                                        <td
                                            //@ts-ignore
                                            rowSpan={cell.rowSpan}
                                            {...cell.getCellProps()}
                                            className={customTableStyle || ""}
                                        >
                                            {cell.render(
                                                "Cell",
                                                customProp && {
                                                    customProp: customProp,
                                                }
                                            )}
                                        </td>
                                    );
                            })}
                        </tr>
                    );
                })}
            </tbody>
        </RBTable>
    );
};

export default ExtendRowTable;
